<script>
/**
 * Componente de gráfico de línea en DASHBOARD.
 * --------------------------------------------
 *
 * Este componente dibuja un gráfico a partir de la data recibida.
 *
 */
import { Line } from "vue-chartjs";

function getCol(matrix, col) {
  var column = [];
  for (var i = 0; i < matrix.length; i++) {
    column.push(matrix[i][col]);
  }
  return column.reverse();
}

export default {
  extends: Line,
  props: ["data", "nightMode"],
  data() {
    return {
      name: "",
      options: {
        tooltips: {
          mode: "index",
          intersect: false,
        },
        hover: {
          mode: "index",
          intersect: false,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                fontColor: this.nightMode === true ? "#000000" : "#ffffff",
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                fontColor: this.nightMode === true ? "#000000" : "#ffffff",
              },
            },
          ],
        },
      },
    };
  },
  
    /**
    * Renderiza y formatea la fecha recibida por props.
    */
  mounted() {
    this.renderLineChart();
    this.formatDates(this.data.sensorData);
  },
  computed: {
    chartData: function () {
      return this.data.sensorData;
    },
  },
  methods: {
    /**
    * formatea la fecha recibida por props para.
    */
    formatDates(dates) {
      let newdates = [];
      dates.forEach((element) => {
        let date = new Date(element[0]);
        let dateFormated =
          date.toISOString().split("T")[0].substring(8, 10) +
          "/" +
          date.toISOString().split("T")[0].substring(5, 7);
        newdates.push([dateFormated]);
      });
      return newdates;
    },
    /**
    * renderiza el gráfico con los datos recibidos por props.
    */
    renderLineChart() {
      this.renderChart(
        {
          labels: getCol(this.formatDates(this.data.sensorData), 0),
          datasets: [
            {
              label: this.formatNames(this.data.name) + " " + this.data.units,
              data: this.formatTwoDecimal(),
              spanGaps: true,
              backgroundColor:
                this.nightMode === true
                  ? "rgba(255, 108, 69, .3)"
                  : "rgba(123, 239, 178, 0.3)",
              borderColor:
                this.nightMode === true
                  ? "rgba(255, 108, 69, 1)"
                  : "rgba(123, 239, 178, 1)",
              pointBackgroundColor: "rgba(171, 71, 188, 0)",
              pointRadius: 0,
              borderWidth: 0.8,
            },
          ],
        },
        this.options
      );
    },
    /**
    * redondea en 2 decimales la data recibida por props.
    */
    formatTwoDecimal() {
      return getCol(this.data.sensorData, 1).filter(v => v !== null).map((v) =>  +v.toFixed(2));
    },
    /**
    * Internacionaliza el nombre de cada sensor a mostrar. 
    */
    formatNames(name) {
      switch (name) {
        case "noise":
          return this.$i18n.t("dashboard_sensor_noise2");
        case "I_BATT_000":
          return this.$i18n.t("dashboard_sensor_current_battery");
        case "PWM_Led_000":
          return this.$i18n.t("dashboard_sensor_led");
        case "SoC_000":
          return this.$i18n.t("dashboard_sensor_battery");
        default:
          return name;
      }
    },
  },
  watch: {
    chartData: function () {
      this.$data._chart.destroy();
      this.renderLineChart();
    },
    nightMode: function () {
      this.$data._chart.destroy();
      this.renderLineChart();
    },
  },
};
</script>
